import moment from 'moment';

export const columns = ({ t }) => [
  {
    title: t('File Name'),
    name: 'uploadedFileName'
  },
  {
    title: t('File Type'),
    name: 'type'
  },
  {
    title: t('Date Added'),
    name: 'createdAt'
  }
];

export const mockedRows = [
  {
    name: '[HC] bol-example-doc',
    type: '[HC] pdf',
    createdAt: '[HC] DEC 28, 2018'
  },
  {
    name: '[HC] 12345678901234shipmentInvoice',
    type: '[HC] doc',
    createdAt: '[HC] DEC 28, 2018'
  },
  {
    name: '[HC] shipment_image_12282018',
    type: '[HC] jpeg',
    createdAt: '[HC] DEC 28, 2018'
  },
  {
    name: '[HC] carrierName_shipmentInvoice_3456789098765432',
    type: '[HC] pdf',
    createdAt: '[HC] DEC 28, 2018'
  },
  {
    name: '[HC] BOL89876543212345678',
    type: '[HC] doc',
    createdAt: '[HC] DEC 27, 2018'
  },
  {
    name: '[HC] image_shipment#4567890123456',
    type: '[HC] jpeg',
    createdAt: '[HC] DEC 27, 2018'
  },
  {
    name: '[HC] document_exampleName',
    type: '[HC] doc',
    createdAt: '[HC] DEC 27, 2018'
  },
  {
    name: '[HC] invoice_carrierName_shipment12345678901234',
    type: '[HC] doc',
    createdAt: '[HC] DEC 26, 2018'
  },
  {
    name: '[HC] ABC123456789012345678_bol',
    type: '[HC] pdf',
    createdAt: '[HC] DEC 23, 2018'
  },
  {
    name: '[HC] bol-shipment5678901234',
    type: '[HC] pdf',
    createdAt: '[HC] DEC 23, 2018'
  },
  {
    name: '[HC] bol-shipment5678901214',
    type: '[HC] pdf',
    createdAt: '[HC] DEC 22, 2018'
  },
  {
    name: '[HC] bol-shipment5678901224',
    type: '[HC] pdf',
    createdAt: '[HC] DEC 22, 2018'
  }
];

export const formatData = items =>
  items.map(item => ({
    type: item.fileTypeId.toLocaleLowerCase(),
    createdAt: moment(item.createdUtc)
      .format('ll')
      .toUpperCase(),
    ...item
  }));

export default {
  columns,
  mockedRows,
  formatData
};
